import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {components} from '../components';

import { Phone } from 'lucide-react'; // 🔄 Importando o ícone de telefone do Lucide
import { theme } from '../constants';


export const VerifyYourPhoneNumber: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  const renderBackground = (): JSX.Element => {
    return <components.Background />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Verifique seu número de telefone'
        goBack={true}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main style={{padding: '77px 20px 0 20px'}}>
        <text.T16 style={{marginBottom: 30}}>
          Enviamos-lhe um SMS com um código para o número +55 (66) 3511-5014.
        </text.T16>


        {/* Campo de telefone atualizado com o ícone do Lucide */}
        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Phone size={18} color={theme.colors.mainDark} />
            </div>
          }
          containerStyle={{ marginBottom: 14 }}
          placeholder="+55 (66) 3511-5014"
        />

        <components.Button
          title='confirm'
          onClick={() => {
            navigate('/ConfirmationCode');
          }}
        />
      </main>
    );
  };

  return (
    <div id='screen'>
      {renderBackground()}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
